export default __webpack_public_path__ + "static/media/Group9212.e8f3962c.svg";